export default __webpack_public_path__ + "static/video-thumbnail-default-8dbb7abc85124b81f9b46bfdff961de0.jpg";